var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.788 19.3344C17.0295 19.5054 17.3407 19.5481 17.6182 19.4431C17.8957 19.3374 18.0997 19.1004 18.1612 18.8131C18.8129 15.7501 20.3939 7.99736 20.9871 5.21111C21.0321 5.00111 20.9571 4.78286 20.7921 4.64261C20.6271 4.50236 20.3984 4.46186 20.1944 4.53761C17.0497 5.70161 7.3652 9.33537 3.40679 10.8001C3.15554 10.8931 2.99205 11.1346 3.0003 11.3994C3.0093 11.6649 3.18779 11.8951 3.44504 11.9724C5.22025 12.5034 7.55044 13.2421 7.55044 13.2421C7.55044 13.2421 8.63942 16.5309 9.20716 18.2034C9.27841 18.4134 9.44265 18.5784 9.6594 18.6354C9.87539 18.6916 10.1064 18.6324 10.2676 18.4801C11.1796 17.6191 12.5896 16.2879 12.5896 16.2879C12.5896 16.2879 15.2685 18.2521 16.788 19.3344ZM8.53067 12.8266L9.78989 16.9801L10.0696 14.3499C10.0696 14.3499 14.9348 9.96162 17.7082 7.46036C17.7892 7.38686 17.8005 7.26386 17.733 7.17761C17.6662 7.09136 17.5432 7.07111 17.451 7.12961C14.2365 9.18237 8.53067 12.8266 8.53067 12.8266Z",
    fill: "#C6FCA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.4da7b95ca076fafe14768cac8f8e9566.svg";
export { ForwardRef as ReactComponent };